import { action } from 'mobx';
import { globalStore, TransactionStore } from '../stores';

const { transactionStore } = globalStore;

export const transactionController = {
  set: action((update: Partial<TransactionStore>) => Object.assign(transactionStore, update)),
  get: transactionStore,
};
